import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于追剧与更新的疑问"
              desc="整理观众最常问的几个问题，涵盖集数、更新节奏与观看方式，帮你在开始追剧前先弄明白。"
              accent="secondary"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-mail-line text-primary-600"></i>
                还有其他问题？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                如果你发现分集介绍与剧情对不上，或者希望我们解析某个具体桥段，欢迎写信告诉我们。
              </p>
              <a
                href="mailto:contact@heiliaodrama.example.com"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                前往联系邮箱
              </a>
            </div>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.q} className="bg-background-100">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-50 cursor-pointer"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}